import { Link } from 'gatsby';
import * as React from 'react';
import { Modal, H4, ButtonOutlined, Button } from './vogdesign';
import { onConsentChange } from '../components/analytics';

const cookiesAcceptedName = 'cookies_accepted';

const cookieValueToBoolean = (value) => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return null;
}

export const getAcceptanceState = () => {
    if (typeof document === 'undefined') return null;
    return cookieValueToBoolean(parseCookies(document.cookie)?.[cookiesAcceptedName]);
};

export const CookiesNotice = ({ cookiesData, serverCookies, forceShow, onHide }) => {
    const [showNotice, setShowNotice] = React.useState( 
        forceShow === true ? true : // Force show dialog for testing
            (!serverCookies || serverCookies?.cookies_accepted === undefined) ? 
                true : // If no cookies acceptance at all - show dialog
                cookieValueToBoolean(serverCookies?.cookies_accepted) === true || cookieValueToBoolean(serverCookies?.cookies_accepted) === false ?
                    false : // If cookies accepted or rejected - hide dialog
                    null // If wrong value - show dialog
    ); // null = loading, false = hide, true = show

    const setAcceptanceCookie = (value) => {
        const d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = `${cookiesAcceptedName}=${value};${expires};path=/`;
    };

    // Watch for changes in forceShow prop
    React.useEffect(() => {
        if (forceShow === true) {
            setShowNotice(true);
        }
    }, [forceShow, showNotice]);

    const onAccept = () => {
        setAcceptanceCookie(true);
        setShowNotice(false);
        onConsentChange(true);
        onHide?.();
    };

    const onReject = () => {
        setAcceptanceCookie(false);
        setShowNotice(false);
        onConsentChange(false);
        onHide?.();
    };

    if (showNotice !== true) {
        return null;
    }

    return (<Modal visible={true} minimized={true}
        onHide={() => { }}
        className="fixed bottom-0 left-0 w-[100vw] lg:w-[600px] border-0 rounded-none lg:rounded-16"
        showHeader={false} showCloseIcon={false} blockScroll={true}
    >
        <div className="p-16 md:p-24 rounded-16 m-16 md:m-40 w-[90vw] md:w-[600px] bg-surface-accent-primary border border-border-accent-light">
            <H4 className="mb-4 md:mb-8 text-text-secondary-secondary">{cookiesData.title}</H4>
            <div className="text-text-secondary-secondary">{cookiesData.description}&nbsp;<Link to={cookiesData.link.link} onClick={() => {setShowNotice(false); onHide?.()}}>{cookiesData.link.title}</Link></div>
            {/*<div className="mt-8 p-2 bg-gray-200 text-xs">Acceptance: {getAcceptanceState('cookies_accepted').toString()}</div>*/}
            <div className="mt-16 md:mt-24 flex justify-between gap-8 md:gap-16 items-center content-center">
                <ButtonOutlined className="grow" onClick={onReject} label={cookiesData.reject}></ButtonOutlined>
                <Button className="grow" onClick={onAccept} label={cookiesData.accept}></Button>
            </div>
        </div>
    </Modal>);
};

export function parseCookies(cookieString) {
    const cookies = {};
    cookieString.split(';').forEach(cookie => {
        const [name, ...rest] = cookie.split('=');
        cookies[name.trim()] = rest.join('=').trim();
    });
    return cookies;
}

